function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import HamburgerMenuComponent from "../hamburger-menu/hamburger-menu-component";
import SideMenuComponent from "./side-menu/side-menu-component";
import TopBarBaseComponent from "../top-bar-base/top-bar-base-component";
import { StyledTopbarMobileComponent } from "./top-bar-mobile-component.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
class TopbarMobileComponent extends PureComponent {
    toggleSlideNavState(isSideNavOpen) {
        this.setState({
            isSideNavOpen
        });
    }
    onScrollModeChange(isInScrollMode) {
        this.setState({
            isInScrollMode
        });
    }
    renderHeaderLinks() {
        const { theme, url, mobileHeaderLinks } = this.props;
        const { isSideNavOpen, isInScrollMode } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            className: "navbar-menu",
            children: [
                /*#__PURE__*/ _jsx(HamburgerMenuComponent, {
                    theme: theme,
                    isInScrollMode: isInScrollMode,
                    changeStateCallback: this.toggleSlideNavState,
                    isOpen: isSideNavOpen
                }),
                /*#__PURE__*/ _jsx(SideMenuComponent, {
                    isOpen: isSideNavOpen,
                    scrollMode: isInScrollMode,
                    mobileHeaderLinks: mobileHeaderLinks
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledTopbarMobileComponent, {
            children: /*#__PURE__*/ _jsxs(TopBarBaseComponent, _object_spread_props(_object_spread({}, this.props), {
                onScrollModeChange: this.onScrollModeChange,
                children: [
                    " ",
                    this.renderHeaderLinks()
                ]
            }))
        });
    }
    constructor(props){
        super(props);
        this.toggleSlideNavState = this.toggleSlideNavState.bind(this);
        this.onScrollModeChange = this.onScrollModeChange.bind(this);
        this.state = {
            isSideNavOpen: false,
            isInScrollMode: false
        };
    }
}
TopbarMobileComponent.defaultProps = {
    url: "//auth.monday.com/login",
    headerBackgroundColor: "white",
    stickyMode: false,
    allowSocialButtons: false,
    socialButtonsColor: "black",
    socialButtonBlogStyle: false
};
export default withGenericConfig(TopbarMobileComponent);
